import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import { DocType } from '@tencent/docs-mime-types';
import * as qs from 'querystringify';
import { getXsrfToken } from "../cgi/cookies";
import { DriveRequest } from "../common/drive-request";
import { DriveApiError } from "../common/error";
import { requestV1Cgi, RetCode } from "../data-source/network-request";
import { COLLABORATION_SPACE_KIND } from "../model/collaboration-space";
import { DEFAULT_CREATOR_DOMAIN, DEFAULT_DOMAIN_ID, DocPolicy, DocSource, DocStatus, DRIVE_FILE_KIND, DriveFileType } from "../model/drive-file";
import { DRIVE_FOLDER_KIND, FOLDER_ATTRIBUTE } from "../model/drive-folder";
import { UserRole } from "../model/permission";
export function getDocInfo(params) {
  return new DocInfoRequest(params).send();
}
export var DocInfoRequest = /*#__PURE__*/function (_DriveRequest) {
  _inherits(DocInfoRequest, _DriveRequest);
  var _super = _createSuper(DocInfoRequest);
  function DocInfoRequest() {
    _classCallCheck(this, DocInfoRequest);
    return _super.apply(this, arguments);
  }
  _createClass(DocInfoRequest, [{
    key: "request",
    value: function request(payload) {
      return requestV1Cgi(payload);
    }
  }, {
    key: "getPayload",
    value: function getPayload(params) {
      var _params$getCollected, _params$getIsAddedMy;
      return {
        method: 'post',
        url: '/cgi-bin/online_docs/doc_info',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: qs.stringify({
          domainId: params.domainId || DEFAULT_DOMAIN_ID,
          localPadId: params.id,
          getCollected: Number((_params$getCollected = params.getCollected) !== null && _params$getCollected !== void 0 ? _params$getCollected : true),
          getIsAddedMy: Number((_params$getIsAddedMy = params.getIsAddedMy) !== null && _params$getIsAddedMy !== void 0 ? _params$getIsAddedMy : true),
          xsrf: getXsrfToken()
        })
      };
    }
  }, {
    key: "getResult",
    value: function getResult(response) {
      if (response.retcode !== RetCode.Success) {
        throw new DriveApiError({
          name: 'DocInfoResultError',
          message: response.msg,
          params: this.params,
          payload: this.payload,
          response: response
        });
      }
      return {
        rawResponse: response,
        file: this.getFileNode(response)
      };
    }

    // eslint-disable-next-line max-lines-per-function
  }, {
    key: "getFileNode",
    value: function getFileNode(response) {
      var _response$doc_policy, _response$doc_url;
      var meta = response.doc_meta;
      var fileNode = {
        kind: '',
        id: meta.doc_id.pad_id,
        title: meta.title,
        collaborationFlag: response.collaboration_flag,
        createTs: meta.create_ts,
        creator: {
          uid: meta.creator_uid,
          nick: response.creator_nick
        },
        docType: meta.doc_type,
        iconUrl: meta.doc_icon,
        lastBrowseTs: 0,
        lastDeleteTs: 0,
        lastModifyTs: meta.last_modify_ts,
        lastModifier: {
          uid: meta.last_modify_uid,
          nick: response.last_modify_nick
        },
        mimeType: response.mime_type,
        owner: {
          uid: meta.owner_uid,
          nick: response.owner_nick
        },
        originParentId: null,
        parentId: null,
        thirdAppId: meta.owner_appid,
        isOwnedByMe: false
      };
      if (meta.doc_type === DocType.Folder && response.collaboration_flag === 1) {
        Object.assign(fileNode, {
          kind: COLLABORATION_SPACE_KIND,
          attribute: null,
          roleId: UserRole.Unauthorized
        });
        return fileNode;
      }
      if (meta.doc_type === DocType.Folder) {
        Object.assign(fileNode, {
          kind: DRIVE_FOLDER_KIND,
          attribute: FOLDER_ATTRIBUTE
        });
        return fileNode;
      }
      Object.assign(fileNode, {
        kind: DRIVE_FILE_KIND,
        ext: meta.ext,
        clientId: null,
        creatorDomainId: DEFAULT_CREATOR_DOMAIN,
        domainId: DEFAULT_DOMAIN_ID,
        driveFileType: DriveFileType.CLOUD,
        groupChatKey: null,
        // 空字符串 fallback 到 null
        groupName: null,
        isCollected: !!response.is_collected,
        isPinned: null,
        lastCollectTs: 0,
        lastPinnedTs: 0,
        officialAuthInfo: null,
        // TODO
        personalizeInfo: meta.personalize_info ? {
          background: meta.personalize_info.background,
          isExpire: meta.personalize_info.is_expire,
          titleColor: _objectSpread(_objectSpread({}, meta.personalize_info.title_color), {}, {
            isVip: meta.is_vip
          }),
          mode: meta.personalize_info.mode
        } : null,
        policy: (_response$doc_policy = response.doc_policy) !== null && _response$doc_policy !== void 0 ? _response$doc_policy : DocPolicy.Private,
        source: DocSource.Personal,
        status: DocStatus.Normal,
        tenantId: meta.tenant_id || null,
        // 空字符串 fallback 到 null
        thumbnailUrl: '',
        url: (_response$doc_url = response.doc_url) !== null && _response$doc_url !== void 0 ? _response$doc_url : '',
        weDriveInfo: meta.wedrive_info ? {
          docId: meta.wedrive_info.doc_id,
          docUrl: meta.wedrive_info.doc_url,
          fileId: meta.wedrive_info.file_id
        } : null
      });
      return fileNode;
    }
  }]);
  return DocInfoRequest;
}(DriveRequest);
//# sourceMappingURL=doc-info.js.map